import { Link } from 'react-router-dom';
import '../../../App.css';

const Vagas = () => {
    return (
        // < !--Feature Start-- >
        <div className="container-fluid feature py-5">
            <div className="container py-5">
                <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="sub-style">
                        <h4 className="sub-title px-3 mb-0">Venha servir conosco</h4>
                    </div>
                    <h1 className="display-3 mb-4">Se sua profissão é movida por propósito, fé e compaixão, talvez seu lugar
                        seja aqui.</h1>
                    <p className="mb-0">Confira algumas das vagas que temos disponíveis:</p>
                </div>
                <div className="row g-4 justify-content-center">
                    <div className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="row-cols-1 feature-item p-4">
                            <div className="col-12">
                                <div className="feature-icon mb-4">
                                    <div className="p-3 d-inline-flex bg-white rounded">
                                        <i className="fas fa-user-md fa-4x text-primary"></i>
                                    </div>
                                </div>
                                <div className="feature-content d-flex flex-column">
                                    <h5 className="mb-4">Pediatra Neonatal</h5>
                                    <p className="mb-0">Vaga para pediatra neonatal</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="row-cols-1 feature-item p-4">
                            <div className="col-12">
                                <div className="feature-icon mb-4">
                                    <div className="p-3 d-inline-flex bg-white rounded">
                                        <i className="fas fa-diagnoses fa-4x text-primary"></i>
                                    </div>
                                </div>
                                <div className="feature-content d-flex flex-column">
                                    <h5 className="mb-4">Fisioterapeuta Neonatal</h5>
                                    <p className="mb-0">Vaga para fisioterapeuta neonatal</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.3s">
                        <div className="row-cols-1 feature-item p-4">
                            <div className="col-12">
                                <div className="feature-icon mb-4">
                                    <div className="p-3 d-inline-flex bg-white rounded">
                                        <i className="fas fa-medkit fa-4x text-primary"></i>
                                    </div>
                                </div>
                                <div className="feature-content d-flex flex-column">
                                    <h5 className="mb-4">Enfermeira</h5>
                                    <p className="mb-0">Vaga para enfermeira</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 text-center wow fadeInUp" data-wow-delay="0.2s">
                        <Link to="/" className="btn btn-primary rounded-pill text-white py-3 px-5">Mais Detalhes</Link>
                    </div>
                </div>
            </div>
            {/* <!--Feature End --> */}
        </div>
    )
};

export default Vagas;